import OffscreenCanvas from '../../classes/PhotoEditor/OffscreenCanvas';

import { drawImageOnCanvas } from './canvas';

import { CROSS_ORIGIN, MIME } from '../../constants/photos';
import { MESSAGE } from '../../constants/notifications';

export function createImageElement({ src, ...attributes }) {
  return new Promise(function executor(resolve, reject) {
    const image = new Image();

    image.crossOrigin = CROSS_ORIGIN.ANONYMOUS;

    for (const attribute in attributes) {
      if (attributes.hasOwnProperty(attribute)) {
        image[attribute] = attributes[attribute];
      }
    }

    image.addEventListener('error', function onError() {
      reject(MESSAGE.FAIL.LOAD_IMAGE);
    });

    image.addEventListener('load', function onLoad() {
      resolve(image);
    });

    image.src = src;
  });
}

export function getTransparentImage({ width, height }) {
  return new OffscreenCanvas(width, height).getImage(MIME.WEBP);
}

export function cropImageTransparency({ format = MIME.WEBP, image: source }) {
  const canvas = drawImageOnCanvas(source, 0, 0, source.width, source.height);
  const ctx = canvas.getContext('2d');
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

  function getAlpha(x, y) {
    return imageData.data[((imageData.width * y) + x) * 4 + 3];
  }

  function scanY(step) {
    for (let y = step > 0 ? 0 : imageData.height - 1; step > 0 ? y <= imageData.height - 1 : y >= 0; y += step) {
      for (let x = 0; x < imageData.width; x += 1) {
        if (getAlpha(x, y) > 0) {
          return y;
        }
      }
    }

    return step > 0 ? imageData.height - 1 : 0;
  }

  function scanX(step) {
    for (let x = step > 0 ? 0 : imageData.width - 1; step > 0 ? x <= imageData.width - 1 : x >= 0; x += step) {
      for (let y = 0; y < imageData.height; y += 1) {
        if (getAlpha(x, y) > 0) {
          return x;
        }
      }
    }

    return step > 0 ? imageData.width - 1 : 0;
  }

  const top = scanY(1);
  const bottom = scanY(-1);
  const left = scanX(1);
  const right = scanX(-1);
  const width = right - left;
  const height = bottom - top;

  canvas.width = width;
  canvas.height = height;

  ctx.clearRect(0, 0, width, height);
  ctx.drawImage(source, left, top, width, height, 0, 0, width, height);

  function onCroppedImage(image) {
    return Promise.resolve({ image, width, height, x: left, y: top });
  }

  return canvas.getImage(format).then(onCroppedImage);
}
